module.exports = __webpack_public_path__ + "img/dot.ee414b9d.svg";